import { useParams } from "react-router-dom";

import { MainContent, PageContent, PageHead, BorderedPanel } from '~/components/Shared/PageParts';
import QRCode from '~/components/Shared/QRCode';
import { getKioskActivationLink } from '~/other/Helper';

export default function KioskLinkPrintPage() {
    const { uuid, activation_key } = useParams();
    const kioskActivationLink = getKioskActivationLink({uuid, activation_key});

    return (
        <MainContent>
            <PageHead>
                <BorderedPanel>
                    <h3 className="page-title zero-blue text-center">Kiosk Activation</h3>
                    <p className="page-description text-center">
                        Scan this QR code to activate kiosk mode. Place this page near the device for easy access.
                    </p>
                </BorderedPanel>
            </PageHead>
            <PageContent>
                <BorderedPanel>
                    <div style={{ 
                        display: 'flex', 
                        flexDirection: 'column', 
                        alignItems: 'center', 
                        gap: '2rem',
                        padding: '2rem'
                    }}>
                        <QRCode 
                            link={kioskActivationLink}
                            size={256}
                            showDownloadAction={false}
                        />
                        <div className="zero-blue text-center">
                            <p>
                                To activate this kiosk, scan the QR code above using a mobile device. 
                            </p>
                            <p>
                                This will open the activation page where you can complete the setup process.
                            </p>
                        </div>
                    </div>
                </BorderedPanel>
            </PageContent>
        </MainContent>
    );
}
